/**
 * Orb palettes (Campaign Studio `orbPalette`): the dashboard's blue / teal /
 * violet relationship rotated to a voice's hue.
 */
export interface IOrbPalette {
   primary: string
   secondary: string
   accent: string
}

const hslHex = (h: number, s: number, l: number) => {
   const a = (s / 100) * Math.min(l / 100, 1 - l / 100)
   const f = (n: number) => {
      const k = (n + h / 30) % 12
      const c = l / 100 - a * Math.max(-1, Math.min(k - 3, 9 - k, 1))
      return Math.round(255 * c)
         .toString(16)
         .padStart(2, '0')
   }
   return `#${f(0)}${f(8)}${f(4)}`
}

export const orbPalette = (hue: number): IOrbPalette => {
   if (Math.abs(hue - 220) < 10)
      return { primary: '#5B8DEF', secondary: '#3DD5C8', accent: '#7C6FF0' }
   return {
      primary: hslHex(hue, 80, 65),
      secondary: hslHex((hue + 315) % 360, 65, 54),
      accent: hslHex((hue + 28) % 360, 70, 68),
   }
}

export const hexToRgba = (hex: string, alpha: number) => {
   const clean = hex.replace('#', '')
   const full =
      clean.length === 3
         ? clean
              .split('')
              .map((c) => c + c)
              .join('')
         : clean
   const r = parseInt(full.slice(0, 2), 16) || 0
   const g = parseInt(full.slice(2, 4), 16) || 0
   const b = parseInt(full.slice(4, 6), 16) || 0
   return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
